// Update the navigation links to use NavLink for better active tracking
import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

const Footer = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (

        <>


            <div className="footer text-center">
                {/* <span>© 2026 Akkount Book — Inventory Management System | Developed By Jaanav Info Technologies</span> */}
                <span>© 2026 Karnataka Police Magazine</span>
            </div>

        </>
    );
};

export default Footer;